export const IMAGE_UPLOAD_TYPES = "jpg, jpeg, png, gif";